import { render, staticRenderFns } from "./elevator.vue?vue&type=template&id=4c801c34&"
import script from "./elevator.vue?vue&type=script&lang=js&"
export * from "./elevator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports